export const mockMarkerInfo = {
  meta: {
    status: 200,
    message: "Success",
    error_detail: {},
  },
  data: {
    map_location: {
      lat: 0,
      lng: 0,
    },
    marker_location: [
      {
        item_id: "INBOM",
        lat: 18.93487,
        lng: 72.85446,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Mumbai (ex Bombay)",
          country: "India",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "No Data Available",
        },
      },
      {
        item_id: "LKCMB",
        lat: 6.96775,
        lng: 79.84391,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Colombo",
          country: "Sri Lanka",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "No Data Available",
        },
      },
      {
        item_id: "JPEIS",
        lat: 31.81888,
        lng: 129.87033,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Eishi",
          country: "United States of America",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "No Data Available",
        },
      },
      {
        item_id: "HKHKG",
        lat: 22.287945,
        lng: 114.18135,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Hong Kong",
          country: "Hong Kong",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "1 day(s) and 21 hour(s)",
        },
      },
      {
        item_id: "INBOM",
        lat: 31.3663,
        lng: 121.614,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Mumbai (ex Bombay)",
          country: "India",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "No Data Available",
        },
      },
      {
        item_id: "LKCMB",
        lat: 22.55628,
        lng: 88.30498,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Colombo",
          country: "Sri Lanka",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "No Data Available",
        },
      },
      {
        item_id: "HKHKG",
        lat: 25.276987,
        lng: 55.296249,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Hong Kong",
          country: "Hong Kong",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "1 day(s) and 21 hour(s)",
        },
      },
      {
        item_id: "HKHKG",
        lat: 120.227028,
        lng: 22.999727,
        marker_type: "port",
        color: "port",
        marker_priority: 1,
        data: {
          port_name: "Hong Kong",
          country: "Hong Kong",
          berth: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          port: {
            time_stamp: "No Data Available",
            info: "No Data Available",
          },
          export_dwell_time_stamp: "No Data Available",
          import_dwell_time_stamp: "1 day(s) and 21 hour(s)",
        },
      },
      {
        item_id: "62ebc1e9e544e6a4350eef1b",
        lat: 18.018607796654972,
        lng: 79.56134981973887,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "A LIMITED",
            "PRODUCTS PVT LTD",
            "GLOBAL LIMITED",
            "XY Co. LTD",
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
            "XYsd Co. LTD",
            "INTERNATIONAL TRADE CO., LTD",
            "XYsdd1Co. LTD",
            "XYsdd1Co2. LTD",
            "Test Company Lagi",
            "Add Company",
            "Delete this Co. LTD",
            "TWIN DRAGON MARKETING INC.",
            "HONGKONG BASE INTERNATIONAL TRADE CO.,LIMITED",
          ],
          email_text:
            "This%20news%20is%20detected%20in%20India%3A%20%0ASumitomo%20Q1%20profit%20rises%2045%25%20on%20stronger%20prices%20of%20coal%2C%20nickel%20%7C%20Hellenic%20Shipping%20News%20Worldwide%20%0AAffecting%2016%20supplier%28s%29%3A%20%0AARVIND%20LIMITED%0APARAMOUNT%20PRODUCTS%20PVT%20LTD%0AASI%20GLOBAL%20LIMITED%0AXY%20Co.%20LTD%0AXYZC%20Co.%20LTD%0AXYZAB%20Co.%20LTD%0AXYZABTes1%20Co.%20LTD%0AXYsd%20Co.%20LTD%0ASUZHOU%20CITY%20BRW%20INTERNATIONAL%20TRADE%20CO.%2C%20LTD%0AXYsdd1Co.%20LTD%0AXYsdd1Co2.%20LTD%0AAsa%20Test%20Company%20Lagi%0AAsa%20Add%20Company%0ADelete%20this%20Co.%20LTD%0ATWIN%20DRAGON%20MARKETING%20INC.%0AHONGKONG%20BASE%20INTERNATIONAL%20TRADE%20CO.%2CLIMITED",
        },
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
      },
      {
        item_id: "62eb667fe1c0bc97c4849d5b",
        lat: 47.71294208539072,
        lng: -55.40505714762512,
        data: {
          news: "BP says gas output rises 7% on year in Q2, sees ongoing high energy prices | Hellenic Shipping News Worldwide",
          summary:
            " BP on Aug. 2 reported a Q2 jump in gas production and underscored its expectation that high energy prices and refinery margins would continue into the autumn . UK major reported a 4% year-on-year increase in overall output to 2.2 million b/d of oil equivalent .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T03:51:00.000Z",
          affected: "N/A",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "",
          suppliers: [],
          email_text:
            "This%20news%20is%20detected%20in%20Canada%3A%20%0ABP%20says%20gas%20output%20rises%207%25%20on%20year%20in%20Q2%2C%20sees%20ongoing%20high%20energy%20prices%20%7C%20Hellenic%20Shipping%20News%20Worldwide",
        },
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
      },
      {
        item_id: "62ec69b7051554643299def2",
        lat: 28.638447245942512,
        lng: 77.22475807605588,
        data: {
          news: "India’s July soyoil imports jump to record on duty free buying-dealers | Hellenic Shipping News Worldwide",
          summary:
            " India’s soyoil imports in July more than doubled from a month ago to a record high . India in late May allowed duty-free imports of 2 million tonne of 2million tonne . Higher purchases by India will support U.S. prices BOc1, but will dent rival palm oil's share in Indian buying .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-05T00:18:00.000Z",
          affected: "N/A",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "",
          suppliers: [],
          email_text:
            "This%20news%20is%20detected%20in%20India%3A%20%0AIndia%E2%80%99s%20July%20soyoil%20imports%20jump%20to%20record%20on%20duty%20free%20buying-dealers%20%7C%20Hellenic%20Shipping%20News%20Worldwide",
        },
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
      },
      {
        item_id: "62eb33e11c3ca9106a63e78d",
        lat: 3.9367415246882573,
        lng: -56.00835340560883,
        data: {
          news: "Europe’s energy majors warm to more oil, gas spending after supply-crisis bonanza | Hellenic Shipping News Worldwide",
          summary:
            " Shell, BP, TotalEnergies, Equinor, and Eni announced over $37 billion in Q2 profits . Major oil and gas companies are being called on to accelerate their shift to clean energy . Most of the sky-high profits are being deployed to shareholders via higher dividends and expanded share buybacks .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T02:28:00.000Z",
          affected: "N/A",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "",
          suppliers: [],
          email_text:
            "This%20news%20is%20detected%20in%20Suriname%3A%20%0AEurope%E2%80%99s%20energy%20majors%20warm%20to%20more%20oil%2C%20gas%20spending%20after%20supply-crisis%20bonanza%20%7C%20Hellenic%20Shipping%20News%20Worldwide",
        },
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
      },
      {
        item_id: "62ec559c051554643299dc83",
        lat: 31.582502972193687,
        lng: -102.9605820930685,
        data: {
          news: "Big Oil offers big returns but keeps spending tight | Hellenic Shipping News Worldwide",
          summary:
            " The West’s energy giants are set to return a record $30 billion to investors after reporting bumper profits in the second quarter of the year . But the top five Western oil and gas companies have shied away from investing more of their combined record profits of nearly $60 billion in new production .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T22:12:00.000Z",
          affected: "N/A",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "",
          suppliers: [],
          email_text:
            "This%20news%20is%20detected%20in%20United%20States%20of%20America%3A%20%0ABig%20Oil%20offers%20big%20returns%20but%20keeps%20spending%20tight%20%7C%20Hellenic%20Shipping%20News%20Worldwide",
        },
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
      },
      {
        item_id: "62eb43575d0b622c542a4d92",
        lat: 53.067421894906346,
        lng: 158.60490714531983,
        data: {
          news: "Oatly posts strong second quarter after expanding global production",
          summary:
            " Swedish oatmilk maker has reported says increased production in key markets has shored up its supply chains and contributed to robust revenue growth across its global retail and foodservice channels . The Malmö-based company had previously reported lower-than-expected production in 2022 and the first quarter of 2022 as new production sites were impacted by supply chain disruption .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T03:50:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "ARVIND LIMITED",
            "PARAMOUNT PRODUCTS PVT LTD",
            "ASI GLOBAL LIMITED",
            "XY Co. LTD",
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
            "XYsd Co. LTD",
            "SUZHOU CITY BRW INTERNATIONAL TRADE CO., LTD",
            "XYsdd1Co. LTD",
            "XYsdd1Co2. LTD",
            "Asa Test Company Lagi",
            "Asa Add Company",
            "Delete this Co. LTD",
            "TWIN DRAGON MARKETING INC.",
            "HONGKONG BASE INTERNATIONAL TRADE CO.,LIMITED",
          ],
          email_text:
            "This%20news%20is%20detected%20in%20Russian%20Federation%3A%20%0AOatly%20posts%20strong%20second%20quarter%20after%20expanding%20global%20production%20%0AAffecting%2016%20supplier%28s%29%3A%20%0AARVIND%20LIMITED%0APARAMOUNT%20PRODUCTS%20PVT%20LTD%0AASI%20GLOBAL%20LIMITED%0AXY%20Co.%20LTD%0AXYZC%20Co.%20LTD%0AXYZAB%20Co.%20LTD%0AXYZABTes1%20Co.%20LTD%0AXYsd%20Co.%20LTD%0ASUZHOU%20CITY%20BRW%20INTERNATIONAL%20TRADE%20CO.%2C%20LTD%0AXYsdd1Co.%20LTD%0AXYsdd1Co2.%20LTD%0AAsa%20Test%20Company%20Lagi%0AAsa%20Add%20Company%0ADelete%20this%20Co.%20LTD%0ATWIN%20DRAGON%20MARKETING%20INC.%0AHONGKONG%20BASE%20INTERNATIONAL%20TRADE%20CO.%2CLIMITED",
        },
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
      },
      {
        item_id: "62eb6eb8e1c0bc97c4849e72",
        lat: -42.33127632094382,
        lng: 171.53381452111984,
        data: {
          news: "Xeneta: Container shipping capacity up by 18.9% between the Far East and the US EC in past three months (yoy) - as spot freight rates trend down",
          summary:
            " Container shipping capacity between Far East and US East Coast has risen sharply from last year . Shippers have shifted volumes towards the East Coast (USEC) and away from the West Coast . This is the equivalent of adding four 8 750 TEU ships a week . In contrast, capacity deployed between USEC and Far East has fallen by 1.7% .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T01:13:00.000Z",
          affected: "1",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: ["TWIN DRAGON MARKETING INC."],
          email_text:
            "This%20news%20is%20detected%20in%20New%20Zealand%3A%20%0AXeneta%3A%20Container%20shipping%20capacity%20up%20by%2018.9%25%20between%20the%20Far%20East%20and%20the%20US%20EC%20in%20past%20three%20months%20%28yoy%29%20-%20as%20spot%20freight%20rates%20trend%20down%20%0AAffecting%201%20supplier%28s%29%3A%20%0ATWIN%20DRAGON%20MARKETING%20INC.",
        },
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
      },
      {
        item_id: "62ebc1e9e544e6a4350eef1b",
        lat: 44.392580,
        lng: 99.127440,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: 58.852121,
        lng: 88.045827,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: 47.090696,
        lng: 26.298017,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: 41.957448,
        lng: 74.853431,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: 39.696621,
        lng: 66.058500,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: 5.302929,
        lng: 102.109051,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: -20.164255,
        lng: 129.318349,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: 26.722920,
        lng: 108.758301,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
      {
        item_id: "",
        lat: 22.881711,
        lng: 121.200700,
        color: "orange",
        marker_type: "news",
        marker_priority: 1,
        data: {
          news: "Sumitomo Q1 profit rises 45% on stronger prices of coal, nickel | Hellenic Shipping News Worldwide",
          summary:
            " Japanese trading house Sumitomo Corp 8053.T said its net profit for the April-June quarter rose 45% to a record . The company stuck to its annual profit forecast of 370 billion yen . Earnings from both resource and non-resource businesses have been stronger than anticipated earlier .",
          category: "DELAYS",
          source_name: "Kavida News",
          email_subject: "Intelligence from Kavida.ai",
          event_timestamp: "2022-08-04T11:41:00.000Z",
          affected: "16",
          ports: [],
          port_affected: "N/A",
          supplier_tier: "1",
          suppliers: [
            "XYZC Co. LTD",
            "XYZAB Co. LTD",
            "XYZABTes1 Co. LTD",
          ],
          email_text:
            "",
        },
      },
    ],
  },
  pagination: {},
};

export const mockIntelligenceCommodity = {
  meta: { status: 200, message: "Success", error_detail: {} },
  data: [
    { label: "All", value: ["Cotton", "Crude Oil", "Sea Freight"] },
    { label: "Cotton", value: ["Cotton"] },
    { label: "Crude Oil", value: ["Crude Oil"] },
    { label: "Sea Freight", value: ["Sea Freight"] },
  ],
  pagination: {},
};
